export default __webpack_public_path__ + "static/media/devguide08.95c3b4fd.md";